import {ISheetLocation, ISheetRange, SheetType} from '@mintdata/mint-kit/api/functions/SheetAPI';
import {SheetId} from '@mintdata/mint-kit/api/models/Identifiers';

export class SheetRangeImpl implements ISheetRange
{
    constructor(public readonly sheetId:SheetId,
                public readonly from:ISheetLocation,
                public readonly to:ISheetLocation)
    {
    }

    public getType():SheetType
    {
        return SheetType.SheetRange;
    }

    public toString():string
    {
        return `${this.from}:${this.to}`;
    }

    public isVector():boolean
    {
        return this.from.rowIndex === this.to.rowIndex || this.from.columnIndex === this.to.columnIndex;
    }

    public static isSheetRange(object:any)
    {
        return object && typeof object.getType === 'function' && object.getType() === SheetType.SheetRange;
    }

    public contains(location:ISheetLocation):boolean
    {
        return this.from.columnIndex <= location.columnIndex && this.to.columnIndex >= location.columnIndex
            && this.from.rowIndex <= location.rowIndex && this.to.rowIndex >= location.rowIndex;
    }
}
